<template>
  <div class="p-0">
    <Employers ref="employersRef" :applicant="applicant" />
    <button
      v-if="measureOneEnabled"
      class="btn btn-primary px-16 py-11 flex-grow-1 w-100 my-25"
      @click="consent"
      :class="[{ loading: loading }]"
      :disabled="loading"
    >
      Consent
    </button>
  </div>
  <ConfirmManualncomeVerificationModal
    ref="modalRef"
    :stip="stip"
    :applicant="applicant"
    :employments="employments"
    :manualCertification="manualCertification"
    @close="closeModal"
  />
  <div class="text-center mt-11">
    <a class="text-decoration-underline" @click="confirmManualCertification"
      >Click here to submit income documents instead</a
    >
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import { useStore } from "vuex";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import Employers from "@/components/checklist/income-verification/Employers.vue";
import ConfirmManualncomeVerificationModal from "@/components/modals/ConfirmManualncomeVerificationModal.vue";

const store = useStore();

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}

const props = withDefaults(defineProps<Props>(), {});

const modalRef = ref<InstanceType<typeof ConfirmManualncomeVerificationModal> | null>();
const employersRef = ref<InstanceType<typeof Employers> | null>();

const manualCertification = ref<boolean>(false);

const measureOneEnabled = computed<boolean>(() => store.state.configuration?.measureOneEnabled);
const loading = computed<boolean>(() => modalRef.value?.loading || false);
const employers = computed(() => (employersRef.value ? employersRef.value?.employers : []));
const employments = computed(() => {
  return employersRef.value ? employersRef.value?.employments : ([] as string[]);
});

async function consent() {
  await modalRef.value?.handleAutomatedIncomeVerificationConsent();
}

function closeModal() {
  modalRef.value?.closeModal();
}

function confirmManualCertification() {
  manualCertification.value = true;
  modalRef.value?.openModal();
}

defineExpose({
  employers,
  employments,
  employersRef,
  modalRef,
});
</script>

<style scoped>
* {
  font-family: "Montserrat";
}

a {
  margin-top: 11px;
  line-height: normal;
  text-decoration: underline;
}

.mt-11 {
  margin-top: 11px;
}

a:hover {
  text-decoration: underline;
}
</style>
